import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import InfoPanel from './info-panel';

import { informationYouNeedBulletContent, mrsText, thingsToDoBulletContent } from '../constants';

import type { ThankYouSubComponentProps } from '.';

const InfoWrapper = styled.div`
  align-items: center;
  background-color: ${COLORS.lightestGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px auto;
  padding-bottom: 30px;

  div {
    width: 45%;
  }

  p {
    font-size: 18px;
    line-height: 24px;
  }
`;

const InformationYouNeed = ({ activeFlow }: ThankYouSubComponentProps) => (
  <InfoWrapper>
    <InfoPanel headingText="Information you'll need to set up Returns" content={informationYouNeedBulletContent} />
    <InfoPanel headingText={mrsText.thingsYouNeedToDoHeading} content={thingsToDoBulletContent(activeFlow)} />
  </InfoWrapper>
);

export default InformationYouNeed;
